import { configureStore } from '@reduxjs/toolkit'
import loginReducer from '../login/login'
import adminReducer from "../login/adminSlice";


const store = configureStore({
  reducer: {
    admin:loginReducer,
    user:adminReducer
  }
})

export default store